import { useState } from "react";
import { ChevronRight, ChevronLeft, X } from "lucide-react";
import { useSetup } from "../SetupContext";
import { teamMembers } from "../../../data/mock";

const ROLE_COLORS: Record<string, string> = { Admin: "#e0044e", Editor: "#3265aa", Viewer: "#9ca3af" };

export function SubStep4({
  onNext,
  onBack,
  onCancel,
}: {
  onNext: () => void;
  onBack: () => void;
  onCancel: () => void;
}) {
  const { form, setField } = useSetup();
  const [newRole, setNewRole] = useState("Viewer");
  const [memberRoles, setMemberRoles] = useState<Record<string, string>>({
    "tm-1": "Admin", "tm-2": "Editor", "tm-3": "Viewer",
  });

  const toggleMember = (id: string) => {
    const next = form.teamMemberIds.includes(id)
      ? form.teamMemberIds.filter((i) => i !== id)
      : [...form.teamMemberIds, id];
    setField("teamMemberIds", next);
  };

  return (
    <div>
      <div className="setup-form-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
        <div>
          <div className="setup-form-title">Step 4 · Users & access</div>
          <div className="setup-form-desc">Assign reviewers, role permissions, and workflow ownership.</div>
        </div>
        <button type="button" className="btn btn--outline btn--small addUser">+ Add new user</button>
      </div>

      <div className="users-table-header">
        {/* <div className="form-grid">
          <div className="form-group">
            <label className="form-group__label" htmlFor="addMember">Add Team Member</label>
            <input id="addMember" className="form-group__input" placeholder="Search by name or email…" />
          </div>
          <div className="form-group">
            <label className="form-group__label" htmlFor="newRole">Role</label>
            <div className="form-group__select-wrap">
              <select
                id="newRole"
                className="form-group__select"
                value={newRole}
                onChange={(e) => setNewRole(e.target.value)}
              >
                {["Viewer", "Editor", "Admin"].map((r) => <option key={r}>{r}</option>)}
              </select>
            </div>
          </div>
        </div> */}
      </div>

      <div style={{ border: "1px solid #E5E7EB", borderRadius: 10, overflow: "hidden" }}>
        <div style={{ overflowX: "auto" }}>
          <table className="users-table" aria-label="Project team members" style={{ minWidth: 690 }}>
          <thead>
            <tr>
              <th scope="col">User</th>
              <th scope="col">Department</th>
              <th scope="col">Role</th>
              <th scope="col">Access</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {teamMembers.map((u) => {
              const active = form.teamMemberIds.includes(u.id);
              const role   = memberRoles[u.id] ?? "Viewer";
              const color  = ROLE_COLORS[role] ?? "#9ca3af";
              return (
                <tr key={u.id} style={{ opacity: active ? 1 : 0.45, transition: "opacity 0.2s" }}>
                  <td>
                    <div className="user-cell">
                      <div className={`user-avatar ${u.avatarCls}`}>{u.initials}</div>
                      <div>
                        <div className="user-name">{u.name}</div>
                        <div className="user-email">{u.email}</div>
                      </div>
                    </div>
                  </td>
                  <td>{u.dept}</td>
                  <td>
                    <select
                      value={role}
                      onChange={(e) => setMemberRoles((prev) => ({ ...prev, [u.id]: e.target.value }))}
                      style={{ border: "none", background: "transparent", fontSize: 12, fontWeight: 600, color, cursor: "pointer" }}
                      disabled={!active}
                      aria-label={`Role for ${u.name}`}
                    >
                      {["Viewer", "Editor", "Admin"].map((r) => <option key={r}>{r}</option>)}
                    </select>
                  </td>
                  <td>
                    <span style={{ display: "inline-block", width: 56, height: 18, borderRadius: 4, background: `${color}22` }} title={role} aria-label={`${role} access level`} />
                  </td>
                  <td>
                    <button type="button" className="btn btn--ghost btn--small" onClick={() => toggleMember(u.id)}>
                      {active ? "Remove" : "Add"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
          </table>
        </div>
      </div>

      <div className="wizard-action-bar" style={{ marginTop: 24 }}>
        <button type="button" className="action-bar__cancel btn btn--outline" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn--outline m-left-auto" onClick={onBack}>
          <ChevronLeft size={14} /> Back
        </button>
        <button type="button" className="btn btn--primary" onClick={onNext}>
          Continue
        </button>
      </div>
    </div>
  );
}
